import { api } from "@/lib/api";

// P-fix (Issue 2) — single source of truth for route access, mirroring menu visibility.
// The full nav registry (path → required MODULE.ACTION permissions) is fetched once and
// cached, so ProtectedRoute can gate access with the exact same permission model the
// server uses to decide sidebar visibility.

let _cache = null;
let _promise = null;

export function fetchNavRegistry() {
  if (_cache) return Promise.resolve(_cache);
  if (_promise) return _promise;
  _promise = api.get("/me/navigation/registry")
    .then((r) => { _cache = r.data?.items || []; return _cache; })
    .catch(() => { _cache = []; return _cache; })
    .finally(() => { _promise = null; });
  return _promise;
}

export function clearNavRegistry() { _cache = null; }

// Longest-prefix resolution: returns the required permission codes for `pathname`,
// or null when no nav module governs it. The bare "/app" landing (ECC index) is left
// universal so every authenticated user keeps a home page.
export function resolveRequiredPerms(items, pathname) {
  if (!items || !pathname) return null;
  if (pathname === "/app" || pathname === "/app/") return null;
  let best = null;
  for (const it of items) {
    const p = it.path;
    if (!p || p === "/app") continue;
    const exact = pathname === p;
    const child = !it.end && (pathname === p || pathname.startsWith(p + "/"));
    if (exact || child) {
      if (!best || p.length > best.path.length) best = it;
    }
  }
  return best ? (best.permissions || []) : null;
}
